module.exports = __webpack_public_path__ + "img/Noctiluca-Process-7.603c8819.png";